<img [src]="data.image" alt="" *ngIf="data.image" style="height: 100%;width: 100%;" class="zoomImage" />